import React from 'react';
import { Radio, RadioGroup, FormControl, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';

export const KeepConstant = ({ isModEdit }: { isModEdit: boolean }) => {
  const { t } = useTranslation();
  const { control, getValues, setValue } = useFormContext();

  const handleRadioChange = e => {
    const newValue = e.target.value === 'true' || e.target.value === true ? 'true' : 'false';
    setValue('keepConstant', newValue);
  };
  return (
    <FormControl>
      <Typography component="span" style={{ color: 'theme.palette.system.darkGray' }}>{`${t(
        'placement.placementMods.assignmantLength',
      )}`}</Typography>
      <Controller
        control={control}
        name={'keepConstant'}
        render={({ field: { onChange, ...rest } }) => {
          return (
            <FormControl disabled={!isModEdit}>
              <RadioGroup
                row
                value={getValues('keepConstant')}
                name={'keepConstant'}
                onChange={e => {
                  handleRadioChange(e);
                  onChange(e);
                }}
              >
                <FormControlLabel
                  checked={getValues('keepConstant') === true || getValues('keepConstant') === 'true' ? true : false}
                  control={<Radio disableFocusRipple disableRipple disableTouchRipple />}
                  label={'Yes'}
                  value={`true`}
                />
                <FormControlLabel
                  checked={getValues('keepConstant') === false || getValues('keepConstant') === 'false' ? true : false}
                  control={<Radio disableFocusRipple disableRipple disableTouchRipple />}
                  label={'No'}
                  value={`false`}
                />
              </RadioGroup>
            </FormControl>
          );
        }}
      />
    </FormControl>
  );
};

